"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Hreflang = function Hreflang(_ref) {
  var href = _ref.href,
      lang = _ref.lang;
  return _react.default.createElement("link", {
    rel: "alternate",
    hrefLang: lang,
    href: href
  });
};

Hreflang.propTypes = {
  href: _propTypes.default.string.isRequired,
  lang: _propTypes.default.oneOf(['x-default', 'en', 'de', 'es', 'fr', 'ja', 'pt']).isRequired
};
var _default = Hreflang;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/Hreflang.js
// module id = 257
// module chunks = 0